import { Step } from './types';

interface StepIndicatorProps {
  step: Step;
  isAuthenticated: boolean;
}

export function StepIndicator({ step, isAuthenticated }: StepIndicatorProps) {
  const allSteps: { key: Step; label: string }[] = [
    { key: 'guest-info', label: 'Seus dados' },
    { key: 'payment', label: 'Pagamento' },
    { key: 'confirm', label: 'Confirmar' },
  ];
  const steps = isAuthenticated ? allSteps.filter((s) => s.key !== 'guest-info') : allSteps;
  const currentIndex = steps.findIndex((s) => s.key === step);

  return (
    <div className="mb-4 sm:mb-6">
      <div className="flex items-center">
        {steps.map((s, idx) => (
          <div key={s.key} className="flex items-center flex-1 last:flex-none">
            <div className="flex flex-col items-center">
              <div
                className={[
                  'w-7 h-7 sm:w-8 sm:h-8 rounded-full flex items-center justify-center text-xs sm:text-sm font-extrabold transition-colors',
                  idx < currentIndex
                    ? 'bg-olivine text-white'
                    : idx === currentIndex
                    ? 'bg-chocolate text-white shadow-md'
                    : 'bg-champagne text-text-light',
                ].join(' ')}
              >
                {idx < currentIndex ? (
                  <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
                  </svg>
                ) : (
                  idx + 1
                )}
              </div>
              <span
                className={[
                  'text-[10px] sm:text-[11px] font-bold uppercase tracking-wide mt-1.5 text-center whitespace-nowrap',
                  idx === currentIndex ? 'text-chocolate-dark' : 'text-text-light',
                ].join(' ')}
              >
                {s.label}
              </span>
            </div>
            {idx < steps.length - 1 && (
              <div className={[
                'h-0.5 flex-1 mx-2 sm:mx-3 rounded-full transition-colors',
                idx < currentIndex ? 'bg-olivine' : 'bg-champagne',
              ].join(' ')} />
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
